import axios from 'axios';
import store from './checkout/s';
import {runInAction} from 'mobx';
import {Portal, getAntiForgeryToken} from './util';

declare var ga: any;
declare var dataLayer: any[];
declare var klaviyo: any[];
declare function marketing_atc(_arr: ga4_item[]);
declare function marketing_purchase(_arr: ga4_item[]);
declare var __company_name: string;
declare var __domain_name: string;

const req = (_url: string, o: IAPIContainer): Promise<IAPIContainer> => {
    // console.log('req', o);
    // console.log(JSON.stringify(o).length, o);

    const config = {
        headers: {
            RequestVerificationToken: getAntiForgeryToken(),
        },
    };

    const x = 1;
    return axios
        .post(_url, o, config)
        .then(response => {
            // console.log('resp', response.data);
            if (response.status === 500) {
                console.error(JSON.parse(response.data));
            }
            return response.data as IAPIContainer;
        })
        .catch(err => {
            console.error(err);
            return err;
        });
};

// TODO FIX MARKETING
export const checkout = async (k: string): Promise<boolean> => {
    const _url: string = '/api/checkout';
    runInAction(() => {
        // approved ria
        checkout_set_gift_messages();
    });

    const isError: boolean = k === 'error-log' ? true : false;

    // console.log(k);
    const o: IAPIContainer = {
        route: isError ? 'error' : 'checkout',
        key: k,
        auth: '',
        id: 0,
        msg: '',
        payload: JSON.stringify(store.checkout),
        ip: '',
        numbers_int: [],
        numbers_dec: [],
        booleans: [],
        debug: [],
    };

    if (k === 'cc-place-order') {
        runInAction(() => {
            // approved ria
            store.checkout.billing.ccNumber.value = '';
            store.checkout.billing.ccExp.value = '';
            store.checkout.billing.ccCSC.value = '';
        });
    }

    if (isError) {
        o.payload = encodeURI(store.errorLogInfo);
        o.msg = encodeURI(store.errorLog);
    }

    const _oldStep = store.checkout.cstep;
    // console.log('old ' + k, _oldStep);

    return req(_url, o)
        .then(x => {
            if (isError) {
                return true;
            }
            if (x.debug != undefined && x.debug.length > 0) {
                for (let i = 0; i < x.debug.length; i++) {
                    // console.log(JSON.parse(x.debug[i]));
                }
            }

            if (x.key === 'places-autocomplete') {
                runInAction(() => {
                    // approved ria
                    store.checkout.ship.google_autocomplete = JSON.parse(x.payload) as IPlacePredictions[];
                });
                return true;
            } else if (x.key === 'get-est') {
                var _d = JSON.parse(x.payload) as ICartPricing;
                if ((!store.checkout.cart.pricing.shipping || store.checkout.cart.pricing.shipping <= 0) && _d && _d.isEstShipping) {
                    runInAction(() => {
                        // approved ria
                        store.checkout.cart.pricing.isEstShipping = true;
                        store.checkout.cart.pricing.isEstTaxes = true;
                        store.checkout.cart.pricing.shipping = _d.shipping;
                        store.checkout.cart.pricing.tax = _d.tax;
                        // console.log('set est');
                    });
                }
                // console.log('est', _d);
                return true;
            } else if (x.key === 'addr-ship-address-book-id' || x.key === 'addr-bill-address-book-id') {
                return true;
            } else if (x.key === 'token-reset') {
                return true;
            }

            const _latest: ICheckoutObject = JSON.parse(x.payload) as ICheckoutObject;
            // console.log('new from server via key ' + k, _latest.CheckoutType);

            // only sync prices with servers if the last request was a sync from client to server
            runInAction(() => {
                // approved ria
                if (o.key.includes('sync')) {
                    store.checkout.cart.pricing = JSON.parse(JSON.stringify(_latest.cart.pricing));
                } else {
                    const copy = JSON.parse(JSON.stringify(_latest));
                    if (k === 'coord' || k === 'get-est') {
                        // console.log('force setting to', storeCheckout.checkout.cstep);
                        copy.cstep = store.checkout.cstep;
                        // copy.cstep = _oldStep;
                    }
                    store.checkout = copy;
                }

                checkout_set_gift_messages();
            });

            if (_oldStep !== store.checkout.cstep || store.uiCheckout.newCheckout) {
                store.uiCheckout.newCheckout = false;
                var _ga4Items = getItems();
                switch (store.checkout.cstep) {
                    case ICheckoutStep.cart:
                        ga4_view_cart();
                        v4_klaviyo_atc();
                        marketing_atc(_ga4Items);
                        break;

                    case ICheckoutStep.checkout:
                        v4_ga_checkoutStep(1);
                        ga4_begin_checkout();
                        v4_klaviyo_cart();
                        break;

                    case ICheckoutStep.oci:
                        ga4_begin_checkout();
                        v4_ga_checkoutStep(2);
                        break;

                    case ICheckoutStep.shipping_zip:
                        v4_klaviyo_cart();
                        v4_ga_checkoutStep(3);
                        break;

                    case ICheckoutStep.shipping:
                    case ICheckoutStep.shipping_correction:
                        ga4_add_shipping_info();
                        break;

                    case ICheckoutStep.shipping_methods:
                        v4_ga_checkoutStep(3);
                        break;

                    case ICheckoutStep.paymentAddr:
                        ga4_add_payment_info();
                        v4_ga_checkoutStep(4);
                        break;

                    case ICheckoutStep.payment:
                        ga4_add_payment_info();
                        v4_ga_checkoutStep(5);
                        break;

                    default:
                }
            }

            if (k === 'places-autocomplete-select') {
                // console.log('places-autocomplete-select done');
            }

            return true;
        })
        .catch(err => {
            console.error(err);
            return false;
        });

    function v4_ga_checkoutStep(_step) {
        try {
            const dle = {
                event: 'checkout',
                ecommerce: {
                    checkout: {
                        actionField: {step: _step, option: store.checkout.CheckoutType.toString()},
                        products: store.checkout.cart.items.map(x => {
                            const _prod: old_gaProduct = {
                                id: x.productId.toString(),
                                name: x.title2,
                                brand: 'CHC',
                                category: x.gaCategory,
                                variant: x.gaVariant,
                                coupon: x.gaDiscountCode,
                                position: x.gaPosition,
                                list: x.gaList,
                                itemId: x.itemId,
                                quantity: x.qty,
                            };
                            return _prod;
                        }),
                    },
                },
            };
            dataLayer.push(dle);
        } catch (err) {
            console.error(err);
        }
    }

    function getItems(): ga4_item[] {
        return store.checkout.cart.items.map(x => {
            const _prod: ga4_item = {
                item_id: x.itemId.toString(),
                item_name: x.title2,
                item_brand: 'CHC',
                item_category: x.gaCategory,
                item_category2: x.title1,
                item_variant: x.gaVariant,
                coupon: x.gaDiscountCode,
                index: x.gaPosition,
                item_list_name: x.gaList,
                quantity: x.qty,
                currency: 'USD',
                price: x.price,
                location_id: 'ChIJUcHLaPbi54kRtbVMrbSH4MU',
            };
            return _prod;
        });
    }

    function ga4_begin_checkout() {
        const rti = getRetargetItems();
        const dle0: IGA4_dle_event_add_to_cart = {
            event: 'add_to_cart',
            ecommerce: {
                currency: 'USD',
                value: store.checkout.cart.pricing.total,
                items: getItems(),
            },
            retarget_items: rti,
            value: Math.round(rti.reduce((sum, item) => sum + item.value, 0)),
            ecomm_prodid: rti.map(function (item) {
                return item.id;
            }),
            ecomm_pagetype: 'basket',
            ecomm_totalvalue: Math.round(rti.reduce((sum, item) => sum + item.value, 0)),
            ecomm_inst: rti[0].inst,
        };
        dataLayer.push(dle0);

        const dle: ga4_dle_begin_checkout = {
            event: 'begin_checkout',
            ecommerce: {
                currency: 'USD',
                value: store.checkout.cart.pricing.total,
                coupon: store.checkout.code_promo_text,
                items: getItems(),
            },
            retarget_items: rti,
            value: Math.round(rti.reduce((sum, item) => sum + item.value, 0)),
            ecomm_prodid: rti.map(function (item) {
                return item.id;
            }),
            ecomm_pagetype: 'basket',
            ecomm_totalvalue: Math.round(rti.reduce((sum, item) => sum + item.value, 0)),
            ecomm_inst: rti[0].inst,
        };

        dataLayer.push(dle);

        dataLayer.push({
            event: 'addToCart',
        });
    }

    function ga4_view_cart() {
        const dle: ga4_dle_view_cart = {
            event: 'view_cart',
            ecommerce: {
                currency: 'USD',
                value: store.checkout.cart.pricing.total,
                items: getItems(),
            },
        };
        // console.log(dle);
        dataLayer.push(dle);
    }

    function ga4_add_shipping_info() {
        const rti = getRetargetItems();
        const dle: ga4_dle_add_shipping_info = {
            event: 'add_shipping_info',
            ecommerce: {
                currency: 'USD',
                value: store.checkout.cart.pricing.total,
                coupon: store.checkout.code_promo_text,
                shipping_tier: store.checkout.ship.shipMethod?.desc,
                items: getItems(),
            },
            retarget_items: rti,
            value: Math.round(rti.reduce((sum, item) => sum + item.value, 0)),
            ecomm_prodid: rti.map(function (item) {
                return item.id;
            }),
            ecomm_pagetype: 'basket',
            ecomm_totalvalue: Math.round(rti.reduce((sum, item) => sum + item.value, 0)),
            ecomm_inst: rti[0].inst,
        };
        dataLayer.push(dle);
    }

    function ga4_add_payment_info() {
        const rti = getRetargetItems();
        const dle: ga4_dle_add_payment_info = {
            event: 'add_payment_info',
            ecommerce: {
                currency: 'USD',
                value: store.checkout.cart.pricing.total,
                coupon: store.checkout.code_promo_text,
                payment_type: store.checkout.CheckoutType === ICheckoutType.normal ? 'Credit Card' : store.checkout.CheckoutType === ICheckoutType.paypal_express ? 'PayPal Express' : store.checkout.CheckoutType === ICheckoutType.stripe_express ? 'Stripe' : 'Other',
                items: getItems(),
            },
            retarget_items: rti,
            value: Math.round(rti.reduce((sum, item) => sum + item.value, 0)),
            ecomm_prodid: rti.map(function (item) {
                return item.id;
            }),
            ecomm_pagetype: 'basket',
            ecomm_totalvalue: Math.round(rti.reduce((sum, item) => sum + item.value, 0)),
            ecomm_inst: rti[0].inst,
        };
        dataLayer.push(dle);
    }

    function getRetargetItems() {
        var _items = getItems();
        var prodArr: any[] = [];
        _items.map(x => {
            prodArr.push({
                id: x.item_id,
                google_business_vertical: 'retail',
                value: x.price,
                prod_type: x.item_category,
                inst: x.item_category2,
                portal: Portal?.PortalID.toString(),
            });
        });
        return prodArr;
    }

    function v4_klaviyo_atc() {
        if (store.checkout.isMyFrames || Portal?.DisableKlaviyo) {
            return;
        }

        try {
            const _klaviyoProd: any = [];
            for (let z = 0; z < store.checkout.cart.items.length; z++) {
                _klaviyoProd.push({
                    ProductID: store.checkout.cart.items[z].productId.toString(),
                    SKU: store.checkout.cart.items[z].itemId,
                    ProductName: store.checkout.cart.items[z].title2,
                    Quantity: store.checkout.cart.items[z].qty,
                    ItemPrice: store.checkout.cart.items[z].price,
                    RowTotal: store.checkout.cart.items[z].price,
                    ProductURL: store.checkout.cart.items[z].URL,
                    ImageURL: store.checkout.cart.items[z].imgFull == undefined || store.checkout.cart.items[z].imgFull.length < 1 ? `https://${Portal?.IMGDomain}/i/${store.checkout.cart.items[z].productId.toString()}_1280_1280.png` : `${store.checkout.cart.items[z].imgFull}`,
                    ProductCategories: [Portal && Portal.PortalID < 1 ? 'Diploma Frames' : Portal?.PortalID === 1 ? 'Custom Frames' : 'Military Frames'],
                });
            }

            if (_klaviyoProd.length > 0) {
                klaviyo.push([
                    'track',
                    'Added to Cart',
                    {
                        $value: _klaviyoProd[_klaviyoProd.length - 1].ItemPrice * _klaviyoProd[_klaviyoProd.length - 1].Quantity,
                        AddedItemProductName: _klaviyoProd[_klaviyoProd.length - 1].ProductName,
                        AddedItemProductID: _klaviyoProd[_klaviyoProd.length - 1].ProductID.toString(),
                        AddedItemSKU: _klaviyoProd[_klaviyoProd.length - 1].SKU,
                        AddedItemCategories: [Portal && Portal.PortalID < 1 ? 'Diploma Frames' : Portal?.PortalID === 1 ? 'Custom Frames' : 'Military Frames'],
                        AddedItemImageURL: _klaviyoProd[_klaviyoProd.length - 1].ImageURL.replace('.com//', '.com/'),
                        AddedItemURL: _klaviyoProd[_klaviyoProd.length - 1].URL,
                        AddedItemPrice: _klaviyoProd[_klaviyoProd.length - 1].ItemPrice,
                        AddedItemQuantity: _klaviyoProd[_klaviyoProd.length - 1].Quantity,
                        ItemNames: _klaviyoProd.map(x => x.ProductName),
                        CheckoutURL: `${__domain_name}/cart`,
                        Items: _klaviyoProd,
                    },
                ]);
            }
        } catch (err) {
            console.error(err);
        }
    }

    function v4_klaviyo_cart() {
        if (store.checkout.isMyFrames || Portal?.DisableKlaviyo) {
            return;
        }

        try {
            const _klaviyoProd: any = [];
            for (let z = 0; z < store.checkout.cart.items.length; z++) {
                _klaviyoProd.push({
                    ProductID: store.checkout.cart.items[z].productId.toString(),
                    SKU: store.checkout.cart.items[z].itemId,
                    ProductName: store.checkout.cart.items[z].title2,
                    Quantity: store.checkout.cart.items[z].qty,
                    ItemPrice: store.checkout.cart.items[z].price,
                    RowTotal: store.checkout.cart.items[z].price,
                    ProductURL: store.checkout.cart.items[z].URL,
                    ImageURL: store.checkout.cart.items[z].imgFull == undefined || store.checkout.cart.items[z].imgFull.length < 1 ? `https://${Portal?.IMGDomain}/i/${store.checkout.cart.items[z].productId.toString()}_1280_1280.png` : `${store.checkout.cart.items[z].imgFull}`,
                    ProductCategories: [Portal && Portal.PortalID < 1 ? 'Diploma Frames' : Portal?.PortalID === 1 ? 'Custom Frames' : 'Military Frames'],
                });
            }

            klaviyo.push([
                'track',
                'Started Checkout',
                {
                    $event_id: `${store.checkout.cart.cartId.toString()}_${Math.round(new Date().getTime() / 1000)}`,
                    $value: store.checkout.cart.pricing.total,
                    ItemNames: _klaviyoProd.map(x => x.ProductName),
                    CheckoutURL: `${__domain_name}/cart`,
                    Items: _klaviyoProd,
                },
            ]);
        } catch (err) {
            console.error(err);
        }
    }
};

function checkout_set_gift_messages() {
    store.checkout.giftMessages = [
        {
            GiftMessageID: 1,
            GiftMessage: 'Congratulations and Best Wishes on Your Graduation!',
            Name: 'Best Wishes on Your Graduation',
        },
        {
            GiftMessageID: 2,
            GiftMessage: 'Congratulations on your success - may the future bring even more!',
            Name: 'Congratulations',
        },
        {
            GiftMessageID: 3,
            GiftMessage: 'Wishing You A Very Merry Christmas!',
            Name: 'Merry Christmas',
        },
        {
            GiftMessageID: 4,
            GiftMessage: 'During the Festival of Lights - May happiness and love brighten your home. Best Wishes at Hanukkah!',
            Name: 'Happy Hanukkah',
        },
        {
            GiftMessageID: 5,
            GiftMessage: 'Best Wishes for a Very Happy Birthday!',
            Name: 'Happy Birthday',
        },
        {
            GiftMessageID: 6,
            GiftMessage: 'Happy Memories...Happy Moments...Happy Anniversary!',
            Name: 'Happy Anniversary',
        },
        {
            GiftMessageID: 7,
            GiftMessage: '',
            Name: ' Write my own message',
        },
    ];
}

export async function klaviyo_identify() {
    try {
        if (!store.checkout.isMyFrames) {
            klaviyo.push([
                'identify',
                {
                    $email: store.checkout.email.value,
                    $first_name: store.checkout.billing.addr.firstName.value,
                    $last_name: store.checkout.billing.addr.lastName.value,
                    $lastPortal: Portal?.PortalID,
                },
            ]);

            // dataLayer.push({event: 'user_data_submission',
            //     user_data: {
            //         email: await sha256(store.checkout.email.value),
            //         phone_number: await sha256(store.checkout.phone.value),
            //     }});
        }
    } catch (err) {
        console.error(err);
    }
}

async function sha256(str) {
    const encoder = new TextEncoder();
    const data = encoder.encode(str.trim().toLowerCase());
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}

export const statevent = async (s: IStatEvent): Promise<void> => {
    // axios.post('/api/info/event', s);
};

export const rerror = async (s: IStatEvent): Promise<void> => {
    axios.post('/api/rerror/event', s);
};

interface IAPIContainer {
    route: string;
    key: string;
    auth: string;
    id: number;
    msg: string;
    payload: string;
    ip: string;
    numbers_int: number[];
    numbers_dec: number[];
    booleans: boolean[];
    debug: string[];
}

interface IStatEvent {
    d1: string;
    d2: string;
    d3: string;
}
